import React, { useEffect, useState } from "react";
import AddEmployeeModal from "../AddEmployeeModal/AddEmployeeModal";
import { useNavigate } from "../../../common/CommonExport";
import { Button, Dropdown, Tooltip } from "antd";
import { useSelector } from "react-redux";
import type { MenuProps } from "antd";
import AddAttenanceModal from "../../LeaveManagement/attenance/AddAttenanceModal";
import AddEmployeePopup from "../new-add-employee/AddEmployeePopup";
import { RolePermission, DashboardState, EmployeeFilter } from "./indexTypes";
import dayjs from "dayjs";


interface DashboardHeaderProps {
    dashBoardCall: () => void;

}
export default function DashboardHeader({ dashBoardCall }: Readonly<DashboardHeaderProps>) {


    const rolePermissions = useSelector((state: DashboardState) => state?.rolePermissions?.rolePermissions);

    const roleName = useSelector((state: DashboardState) => state?.loginUserData?.userData?.data?.role?.name);
    const [isOpen, setIsOpen] = useState(false);
    const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
    const reduxToken = useSelector((state: DashboardState) => state?.employeeTable?.data);
    const [expand, setExpand] = useState<boolean>(false);
    const [bulkUpload, setBulkUpload] = useState<boolean>(false);
    const [bulk_Upload, setBulk_Upload] = useState<string>("");
    const [sendMail, setSendMail] = useState<boolean>(false);
    const [dirty, setDirty] = useState(false);
    const csvFilterData = useSelector(
        (state: DashboardState) => state?.userDashboard?.csvFilterData
    );


    const statusState = useSelector((state: DashboardState) => state.tableFilter?.filterValue);
    const isPastEmployee = statusState === "Past Employees";
    useEffect(() => {
        setExpand(reduxToken);
        setBulk_Upload("employee_bulk_upload");
    }, [reduxToken]);

    useEffect(() => {
        setIsDownloadDisabled(csvFilterData.length === 0);
    }, [csvFilterData]);
    const navigate = useNavigate();
    const handleClose = () => {
        setIsOpen(false);
        if (dirty) {
            dashBoardCall();
        }
    };
    const handelDesignationPopUp = () => {
        // setIsOpen(true);
        setSendMail(true);
    };
    const handelViewProjects = () => {
        navigate("/home/project-list");
    };
    const handelBulkUpload = () => {
        setBulkUpload(true);
    };
    const handleClosed = () => {
        setBulkUpload(false);
    };

    const handelDownload = () => {
        const fieldsMap = [
            { header: "Employee Code", field: "employeeCode" },
            { header: "Employee Name", field: "employeename" },
            { header: "DOB", field: "dateOfBirth" },
            { header: "OfficialMailId", field: "officialMailId" },
            { header: "DOJ", field: "doj" },
            { header: "Grade", field: "grade" },
            { header: "Dept", field: "dept" },
            { header: "Designation", field: "designation" },
            { header: "Reporting To", field: "reportingTo" },
            { header: "Status", field: "status" },
            ...(isPastEmployee
                ? [{ header: "Relieving Date", field: "relievingDate" }]
                : []),

        ];

        const csvRows = [
            fieldsMap.map((f) => f.header).join(","),

            ...csvFilterData.map((row: EmployeeFilter) =>
                fieldsMap
                    .map((f) => {
                        if (f.field === "firstName") {
                            const first = row.firstName ?? "";
                            const last = row.lastName ?? "";
                            return `"${first} ${last}"`.trim();
                        } else if (f.field === "dateOfJoin") {

                            return row.dateOfJoin
                                ? `"${dayjs(row.dateOfJoin).format("DD-MM-YYYY")}"`
                                : `"-"`;
                        } else if (f.field === "dateOfBirth") {

                            return row.dateOfBirth
                                ? `"${dayjs(row.dateOfBirth).format("DD-MM-YYYY")}"`
                                : `"-"`;
                        } else if (f.field === "relievingDate") {

                            return row.relievingDate
                                ? `"${dayjs(row.relievingDate).format("DD-MM-YYYY")}"`
                                : `"-"`;
                        }

                        else {
                            return `"${row[f.field] || "-"}"`;
                        }
                    })
                    .join(",")
            ),
        ];

        const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");


        const formattedDate = dayjs().format("DD-MM-YYYY");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `Employees_List_${formattedDate}.csv`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const items: MenuProps["items"] = [
        {
            key: "1",
            label: (
                <Button onClick={() => handelDesignationPopUp()} className="border-none font-bold ">
                    Add Employee
                </Button>
            ),
        },
        {
            key: "1",
            label: (
                <Button onClick={() => handelBulkUpload()} className="border-none font-bold ">
                    Bulk Upload
                </Button>
            ),
        },
    ];
    const handelCancel = (isLoading: boolean = false) => {
        setSendMail(false);
        dashBoardCall();
    };
    const closeEmployeeModal = (isLoading: boolean = false) => {
        setSendMail(false);
    };
    const userPermission = rolePermissions?.find((permission: RolePermission) => {
        return permission?.component?.name === "User" && permission?.isCreate === true;
    });

    return (
        <div className="container mx-auto max-w-full md:px-14 px-4 header-container">
            <div className="flex justify-between items-center pt-4 ">
                <h3 className="text-primary font-medium">Dashboard</h3>
                <div className="flex flex-auto md:justify-end  md:mt-0 mt-3  mr-7 space-x-2">
                    {!expand && (
                        <Button className=" md:mr-4 mr-2 " type="primary" shape="round" size={"large"} onClick={() => handelViewProjects()}>
                            View Projects
                        </Button>
                    )}

                    {userPermission?.isCreate && (
                        <Dropdown menu={{ items }} placement="bottomRight">
                            <Button type="primary" data-testid="addbutton" shape="circle" size={"large"} className="bulk-upload_dropdown">
                                <span className="material-symbols-outlined">add</span>
                            </Button>
                        </Dropdown>
                    )}
                    {expand && roleName !== "employee" && (
                        <Tooltip placement="bottom" title="Download Employee List">
                            <Button data-testid="downloadSpan" type="primary" shape="circle" className="cursor-pointer " size={"large"} onClick={() => handelDownload()} disabled={isDownloadDisabled}>
                                <span className="material-symbols-outlined">download</span>
                            </Button>
                        </Tooltip>
                    )}
                </div>
                {isOpen && <AddEmployeeModal isOpen={isOpen} handleClose={handleClose} handelDesignationPopUp={handelDesignationPopUp} setIsOpen={setIsOpen} />}
                {bulkUpload && <AddAttenanceModal open={bulkUpload} handleClose={handleClosed} bulk={bulk_Upload} />}
                {sendMail && <AddEmployeePopup open={sendMail} closeEmployeeModal={closeEmployeeModal} handelCancel={handelCancel} setDirty={setDirty} dashBoardCall={dashBoardCall} />}
            </div>
        </div>
    );
}
